import React from 'react'
import './Workouts.css'

const Workouts = () => {
  return (
    <div>Workouts</div>
  )
}

export default Workouts